import { render, staticRenderFns } from "./ItemClassShowHideAdmin.vue?vue&type=template&id=d2d33aba&"
import script from "./ItemClassShowHideAdmin.vue?vue&type=script&lang=js&"
export * from "./ItemClassShowHideAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ItemClassShowHideAdmin.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VDataTable } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VDataTable,
  VFlex,
  VLayout,
})
